export default __webpack_public_path__ + "static/media/ssl_2.090676a2.PNG";